import { defineComponent as _defineComponent } from 'vue'
import { useContext, useRoute } from '@nuxtjs/composition-api';
import TLinkButton from '~/components/atoms/t-link-button.vue';
interface Props {
  collectionTitle: string | null;
  collectionId?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupCta',
  props: {
    collectionTitle: null,
    collectionId: null
  },
  setup(__props: any) {

const props = __props as {
  collectionTitle: string | null;
  collectionId?: number;
};

const $route = useRoute();


const { i18n } = useContext();
const eventButtonClicked = () => {
  const buttonParams = {
    Resource_CTA_Type: 'Resource Collections Banner',
    Page_Country: i18n.locale,
    Page_ID: props.collectionId,
    Page_Name: props.collectionTitle,
    Page_URL: $route.value.path,
  };
};

return { __sfc: true,$route, props, i18n, eventButtonClicked, TLinkButton }
}

})